export default __webpack_public_path__ + "media/images/ui-bg_highlight-hard_70_000000_1x100-485eaacf0adca5834aa66dcbcc0b69df.png";